import React, { useEffect } from "react";
/* Components */
import { useMixPanel } from '../hooks/useMixPanel';
import { useTranslation } from 'react-i18next';
import useUserStore from "../store/useUser.store";
import { MIX_PANEL_EVENTS } from '../utils/constans';
import ShaiaBot from "../components/shaiaBot/shaiabot";
import ToggleSwitch from '../components/form-elements/ToggleSwitch/toggleSwitch';
import SignUpFormHubspot from "../components/form/signUp_Hubspot";

const RegisterHubspot = () => {
  const { sendEvent } = useMixPanel();
  const { i18n } = useTranslation();
  const { setLang } = useUserStore();
  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.registerView);
    localStorage.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const onSwitch = (event) => {
    i18n.changeLanguage(event ? 'en' : 'es')
    setLang(event ? 'en' : 'es')
    localStorage.setItem('lang',event ? 'en' : 'es');
  };

  return (
    <div className="login-wrapper wrapper-hbs">
      <div className='fixed top-4 right-12 sm-max:top-8 sm-max:right-8 hbs-toggle'>
        <ToggleSwitch name='lang' onChange={onSwitch} />
      </div>
      <ShaiaBot />
      <SignUpFormHubspot />
    </div>
  );
};

export default RegisterHubspot;
